import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72')
];

export const server_loads = [];

export const dictionary = {
		"/[[lang=locale]]/(index-page)": [12,[2],[3]],
		"/[[lang=locale]]/(non-auth)/accept-invite": [61,[2],[3]],
		"/[[lang=locale]]/(need-unauth)/account-recovery": [54,[2,11],[3]],
		"/contract-review/preview": [72],
		"/[[lang=locale]]/error": [71,[2],[3]],
		"/[[lang=locale]]/(non-auth)/esign": [62,[2],[3]],
		"/[[lang=locale]]/(non-auth)/esign/auth": [63,[2],[3]],
		"/[[lang=locale]]/(non-auth)/esign/exit": [64,[2],[3]],
		"/[[lang=locale]]/(non-auth)/esign/view": [65,[2],[3]],
		"/[[lang=locale]]/(non-auth)/like-reload": [66,[2],[3]],
		"/[[lang=locale]]/(non-auth)/login/sso/[ssoPartnerType]": [67,[2],[3]],
		"/[[lang=locale]]/(non-auth)/logout": [68,[2],[3]],
		"/[[lang=locale]]/(need-unauth)/reset-password-from-email": [55,[2,11],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-in": [56,[2,11],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-up/direct/email-input": [57,[2,11],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-up/direct/set-password": [58,[2,11],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-up/direct/user-name": [59,[2,11],[3]],
		"/[[lang=locale]]/(non-auth)/sign-up/invite": [69,[2],[3]],
		"/[[lang=locale]]/(non-auth)/sso-sign-in-callback": [70,[2],[3]],
		"/[[lang=locale]]/(need-unauth)/sso-sign-up-callback": [60,[2,11],[3]],
		"/[[lang=locale]]/(need-auth)/welcome": [53,[2,4],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]": [13,[2,4,5],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/account/profile": [30,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/ask-ai": [14,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/ask-ai/projects/[projectKey]": [15,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/calendar": [16,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/contract-draft": [17,[2,4,5,6,7],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/contract-draft/agent": [18,[2,4,5,6,7],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/contract-draft/import": [19,[2,4,5,6,7],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/contract-review": [20,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/documents": [21,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/drafts": [22,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/esign": [23,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/esign/bulk-sends/[externalId]": [24,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/esign/bulk": [44,[2,4,5,9],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/esign/bulk/confirm": [45,[2,4,5,9],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/esign/bulk/prepare": [46,[2,4,5,9],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/esign/bulk/recipients": [47,[2,4,5,9],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/esign/bulk/upload": [48,[2,4,5,9],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/esign/new": [49,[2,4,5,10],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/esign/new/prepare": [50,[2,4,5,10],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/esign/new/signers": [51,[2,4,5,10],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/esign/new/upload": [52,[2,4,5,10],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/esign/send": [25,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/esign/send/bulk": [26,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/esign/send/contracts": [27,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/home": [28,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/members": [31,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/search": [29,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings": [32,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/account": [33,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/apps": [34,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/billing": [35,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/company": [36,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/contract-types": [37,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/members": [38,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/notifications": [39,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/plan": [40,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/plan/checkout": [41,[2,4,5],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/plan/credit-checkout": [42,[2,4,5],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/usage": [43,[2,4,5,8],[3]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';